<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
          <h3>{{ Data.Name }}</h3>
        </el-col>
        <el-col :xs="12" :sm="16" :md="18" :lg="20" :xl="21" class="headmenu">
          <el-button icon="el-icon-switch-button" circle @click="logout"></el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-aside style="width:auto">
        <el-row>
          <el-menu
            :default-active="$route.path"
            :default-openeds="defaultOpeneds"
            :router="true"
            :collapse="collapse"
          >
            <el-submenu index="home">
              <template slot="title">
                <i class="el-icon-coffee-cup"></i>
                <span>开始</span>
              </template>
              <el-menu-item index="/app/list">小程序</el-menu-item>
              <el-menu-item index="/home/nothing">建设中</el-menu-item>
            </el-submenu>
            <el-submenu index="admin">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>设置</span>
              </template>
              <el-menu-item index="/home/password">修改密码</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-row>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      collapse: window.innerWidth < 800, //屏幕宽度小于800 菜单栏使用icon模式
      defaultOpeneds: ["home", "admin"],
    };
  },
  methods: {
    //登出
    logout() {
      this.Data.Admin.Logout().then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style>
.el-header {
  border-bottom: 1px solid #e6e6e6;
  position: relative;
  width: 100%;
  height: 60px;
}
.el-aside {
  border-right: 1px solid #e6e6e6;
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
}
.el-container {
  min-width: 760px;
}
.el-menu {
  border-right: 0 !important;
}

.headmenu {
  padding: 10px 0;
  height: 60px;
  text-align: right;
  color: #cccccc !important;
}
.headmenu .el-button {
  border: 0;
  font-size: 18px;
}
</style>
<style scoped>
.el-main {
  padding-top: 0;
  position: absolute;
  left: 200px;
  right: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
}
</style>

